<template>
  <div class="container-pacientes-agendados">
    <div class="header-pacientes-agendados">
      <div class="header-mostrador-data">
        <span>Pacientes agendados em</span><br/>
        <label>{{ mostradorData }}</label>
      </div>
      <v-spacer/>
      <v-btn color="primary" icon @click="voltarData">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn color="primary" icon @click="avancarData">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <div v-if="pacientesAgendados.length > 0" class="container-pacientes-list">
      <div v-for="paciente in pacientesAgendados" :key="paciente.id">
        <MolensTooltip max-width="300px" posicao="right">
          <div class="item-paciente">
            <label class="max-label">{{ paciente.nomePaciente }}</label>
            <label>&ensp;-&ensp;{{ moment(paciente.dataHoraAgendamento).format('HH:mm') }}</label>
          </div>
          <template #content>
            <div class="container-detalhes">
              <label>{{ paciente.nomeDentista }}</label><br/>
              <span>{{ paciente.descricao }}</span>
            </div>
          </template>
        </MolensTooltip>
      </div>
    </div>
    <div class="nenhum-paciente-agendado" v-else>Nenhum paciente agendado nesta data!</div>
  </div>
</template>

<script>
import moment from 'moment'
import {actionTypes} from '@/core/constants'
import MolensTooltip from '@/views/components/MolensTooltip.vue'

export default {
    name: 'PacientesAgendadosPeriodo',
    components: {MolensTooltip},
    data() {
        return {
            pacientesAgendados: [],
            dataPacientesAgendados: null,
            dataAtual: null,
            dataInicio: null,
            dataFim: null,
            mostradorData: null
        }
    },
    async mounted() {
        this.dataAtual = moment()
        this.setarDataPacientesAgendados()
        await this.buscarPacientesAgendados()
    },
    methods: {
        setarDataPacientesAgendados() {
            this.mostradorData = moment(this.dataAtual).format('DD [de] MMMM')
            this.dataInicio = moment(this.dataAtual).startOf('day').format('YYYY-MM-DD HH:mm')
            this.dataFim = moment(this.dataAtual).endOf('day').format('YYYY-MM-DD HH:mm')
        },
        async voltarData() {
            this.dataAtual = moment(this.dataAtual).subtract(1, 'days')
            this.setarDataPacientesAgendados()
            await this.buscarPacientesAgendados()
        },
        async avancarData() {
            this.dataAtual = moment(this.dataAtual).add(1, 'days')
            this.setarDataPacientesAgendados()
            await this.buscarPacientesAgendados()
        },
        async buscarPacientesAgendados() {
            const input = {
                dataInicio: this.dataInicio,
                dataFim: this.dataFim
            }
            this.setMensagemLoading('Buscando pacientes agendados...')
            const resposta = await this.$store.dispatch(actionTypes.INICIO.BUSCAR_PACIENTES_AGENDADOS, input)
            if (resposta) {
                this.pacientesAgendados = resposta.items
            }
        }
    }
}
</script>


<style scoped lang="stylus">

.container-pacientes-agendados
  box-shadow rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset
  border-radius 5px
  height 350px
  overflow hidden

.header-pacientes-agendados
  display flex
  justify-content right
  border-bottom 1px solid #ddd

.nenhum-paciente-agendado
  height 90%
  display flex
  align-items center
  justify-content center
  text-align center
  padding 5px

.item-paciente
  background-color var(--theme-secondary)
  padding 0 5px
  color white
  border-bottom 1px solid white
  display flex
  align-items center

.item-paciente:hover
  background-color var(--theme-primary)
  cursor pointer

.item-paciente > label:hover
  cursor pointer

.header-mostrador-data
  margin-left 5px
  line-height 1.3

  span
    font-weight bold
    color var(--theme-primary)

.container-pacientes-list
  height 300px
  overflow-y auto

.max-label
  display inline-block
  max-width 80%
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.container-detalhes
  color black

  label
    font-size 15px
    font-weight bold

</style>